export enum USER_ROLE {
  "admin" = "admin",
  "student" = "student",
  "contentCreator" = "content_creator",
}

export type UserRole = `${USER_ROLE}`;
